import React from 'react';

export default function useElementPosition() {
  const isBrowser = typeof window !== 'undefined';
  const ref = React.useRef(null);

  const [position, setPosition] = React.useState({
    left: undefined,
    right: undefined,
    top: undefined,
    bottom: undefined,
  });

  const updatePosition = () => {
    setPosition({
      left: ref.current.getBoundingClientRect().left,
      right: ref.current.getBoundingClientRect().right,
      top: ref.current.getBoundingClientRect().top,
      bottom: ref.current.getBoundingClientRect().bottom,
    });
  };

  React.useLayoutEffect(() => {
    if (isBrowser) {
      window.addEventListener('scroll', updatePosition);
      updatePosition();
    }
    return () => {
      if (isBrowser) window.removeEventListener('scroll', updatePosition);
    };
  }, []);

  return [position, ref];
}
